exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".formGroup[data-v-b8c19f42]{margin:10px 0 0}.formGroup .radioGroup[data-v-b8c19f42]{display:-webkit-box;display:-ms-flexbox;display:flex}.formGroup label.radio[data-v-b8c19f42]{-webkit-box-flex:1;-ms-flex:1 1 50%;flex:1 1 50%;max-width:50%;margin:0 7px 0 0;background:#fff;border:1px solid #dcdfe2;border-radius:40px;cursor:pointer}.formGroup label.radio[data-v-b8c19f42]:last-child{margin-right:0}.formGroup .radio__input[data-v-b8c19f42]{display:none}.formGroup .radio__description[data-v-b8c19f42]{-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;padding:13px 0;color:#dcdfe2;font-weight:400;text-align:center;line-height:1}.formGroup .radio__input:checked+.radio__description[data-v-b8c19f42]{color:#32373f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b8c19f42","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/YearLuck/y2022/formRadio.vue
// module id = 6F05
// module chunks = 0